import React from "react";
import { List, ListItem, ListItemText, Divider } from "@mui/material";

const potentialLabels = {
  0: "Nenhum",
  1: "Baixo",
  2: "Médio",
  3: "Alto",
};

const formatDescription = (description) => {
  if (!description || typeof description !== "string") return description;

  const match = description.match(
    /Potencial alterado:\s*de\s*(\d+)\s*para\s*(\d+)/i
  );

  if (!match) return description;

  const fromCode = Number(match[1]);
  const toCode = Number(match[2]);

  const fromLabel = potentialLabels[fromCode] ?? match[1];
  const toLabel = potentialLabels[toCode] ?? match[2];

  return description.replace(
    /Potencial alterado:\s*de\s*\d+\s*para\s*\d+/i,
    `Potencial alterado: de ${fromLabel} para ${toLabel}`
  );
};

const History = ({ history, handleItemClick, formatDate }) => (
  <List>
    {history?.map((item) => (
      <React.Fragment key={item.id}>
        <ListItem
          onClick={() => handleItemClick(item.id)}
          sx={{ cursor: "pointer" }}
        >
          <ListItemText
            primary={formatDescription(item.description)}
            secondary={formatDate(item.date)}
            primaryTypographyProps={{
              sx: { whiteSpace: "pre-line" },
            }}
          />
        </ListItem>
        <Divider />
      </React.Fragment>
    ))}
  </List>
);

export default History;
